const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 108px 13px 100px',
    cursor: 'pointer',
    position: 'relative',
    borderRadius: '9px 0px 0px 9px',
  },

  selected: {
    backgroundColor: '#f6f9ff',
  },

  label: {
    fontSize: 13,
    letterSpacing: '1px',
    fontWeight: 500,
    color: '#545A61',
    textTransform: 'uppercase',
  },

  labelSelected: {
    color: '#5786d7',
  },

  input: {
    marginTop: 10,
    height: 43,
    backgroundColor: '#FFF',
    border: '1px solid #DDE0E5',
    borderRadius: 6,
    padding: '10px 12px 12px 12px',
    color: '#b3b6ba',
    fontSize: 16,
    boxShadow: '0 1px 2px 0 rgba(243,244,245,0.65)',
  },

  selectedInput: {
    backgroundColor: '#f6f9ff',
  },

  select: {
    marginTop: 10,
    position: 'relative',
  },

  selectArrow: {
    position: 'absolute',
    top: '50%',
    right: '15px',
    marginTop: '-4px',
    pointerEvents: 'none',
  },

  selectInput: {
    appearance: 'none',
    '-webkit-appearance': 'none',
    height: 43,
    backgroundColor: '#FFF',
    border: '1px solid #DDE0E5',
    borderRadius: 6,
    fontSize: 16,
    boxShadow: '0 1px 2px 0 rgba(243,244,245,0.65)',
    outline: 'none',
    display: 'block',
    width: '100%',
    padding: '0 16px',
  },

  multiline: {
    height: 100,
  },

  hidden: {
    marginTop: 10,
    height: 43,
    backgroundColor: '#FFF',
    border: '1px solid #DDE0E5',
    borderRadius: 6,
    padding: 12,
    color: '#b3b6ba',
    fontSize: 16,
    boxShadow: '0 1px 2px 0 rgba(243,244,245,0.65)',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontWeight: 600,
  },

  checkbox: {
    display: 'flex',
    alignItems: 'center',
  },

  checkboxDescription: {
    marginLeft: '8px',
    fontSize: '14px',
  },
});

export default styles;
